
export type ActionPortalType =
  | 'ADD_FILE_TO_REQUEST'
  | 'CHECK_REQUEST_STATUS'
  | 'CANCEL_PERMIT'
  | 'CHECK_PEMIT_VALIDITY'
  | 'UPDATE_VEHICLE_DETAILS'
  | 'RENEWED_PERMIT_OPTION'
  | 'ADD_PERMIT_REQUEST'
  ;

export enum ActionPortalTypes {
  ADD_FILE_TO_REQUEST = 'ADD_FILE_TO_REQUEST',
  CHECK_REQUEST_STATUS = 'CHECK_REQUEST_STATUS',
  CANCEL_PERMIT = 'CANCEL_PERMIT',
  CHECK_PEMIT_VALIDITY = 'CHECK_PEMIT_VALIDITY',
  UPDATE_VEHICLE_DETAILS = 'UPDATE_VEHICLE_DETAILS',
  RENEWED_PERMIT_OPTION = 'RENEWED_PERMIT_OPTION',
  ADD_PERMIT_REQUEST = 'ADD_PERMIT_REQUEST'
};
